var $ = jQuery;

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

$(document).on('ready', function(){
    if($('.location-cta-swiper').length){
      $('.location-cta-swiper').each(function(index){
          var $parent = $(this).parent();
          new Swiper($(this)[0], {
          modules: [Navigation],
          slidesPerView: 4.3,
          loop: false,
          spaceBetween: 16,
          slidesOffsetAfter: 48,
          navigation: {
            prevEl: $parent.find('.location-cta-prev')[0],
            nextEl: $parent.find('.location-cta-next')[0],
          },
          breakpoints: {
            300: {
              slidesPerView: 1.3,
              speed: 800,
            },
            640: {
              slidesPerView: 2.3,
              speed: 800,
            },
            1024: {
              slidesPerView: 3.3,
              speed: 800,
            },
            1400: {
              slidesPerView: 4.3,
            },
          },
        });
      });
    }
  });
